import { Check, Lock } from "lucide-react";
import { SectionHead } from "@/components/landing/Section";

const UNLOCKS = [
  "Itinéraire détaillé heure par heure",
  "Transport résumé + détail pratique (gares, parking, horaires)",
  "Sélection concrète hôtel / activité / restauration",
  "Une vision claire, directement utilisable",
];
const TERMS = ["Paiement unique, sans abonnement", "Accès immédiat après achat", "Une escapade au choix débloquée", "Pas de compte obligatoire"];

export const PremiumValue = () => (
  <section id="premium" data-testid="premium-value-section" className="scroll-mt-16 bg-[#0B131E] grain relative">
    <div className="relative py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <SectionHead dark eyebrow="Premium" title="Débloquez l'escapade complète pour 4,90 €">
          Accédez au détail complet de l'escapade que vous choisissez : transport, hébergement, activité, restauration et logique d'itinéraire claire.
        </SectionHead>
        <ul className="mt-8 space-y-3">
          {UNLOCKS.map((u) => <li key={u} className="flex gap-3 text-gray-200"><Check className="w-5 h-5 text-emerald-400 shrink-0" />{u}</li>)}
        </ul>
      </div>
      <div data-testid="premium-offer-card" className="relative rounded-2xl bg-[#15202B] border-2 border-amber-500/60 p-8 shadow-[0_0_60px_rgba(245,158,11,0.15)]">
        <span className="absolute -top-3.5 left-8 px-3 py-1 rounded-full bg-amber-500 text-[#0B131E] text-xs font-bold uppercase tracking-wider">Paiement unique</span>
        <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-amber-500"><Lock className="w-4 h-4" />Accès Premium</p>
        <p className="mt-4 flex items-baseline gap-2 text-white"><span data-testid="landing-premium-price" className="font-serif text-6xl font-bold">4,90 €</span><span className="text-gray-400">TTC</span></p>
        <p className="mt-2 text-sm text-gray-400">par escapade choisie · paiement unique</p>
        <ul className="mt-6 grid sm:grid-cols-2 gap-3">
          {TERMS.map((t) => <li key={t} className="flex gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />{t}</li>)}
        </ul>
        <a href="#recherche" data-testid="premium-section-cta-btn" className="mt-8 w-full inline-flex items-center justify-center h-12 rounded-full bg-amber-500 hover:bg-amber-400 text-[#0B131E] font-semibold transition-colors">
          Trouver mon escapade
        </a>
        <p className="mt-3 text-center text-xs text-gray-500">Les 3 propositions sont gratuites. Vous ne payez que si l'une d'elles vous plaît.</p>
      </div>
    </div>
  </section>
);
